import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";

interface AnswerNoteProps {
  title: string;
  body: React.ReactNode;
  faqAnchor?: string;
}

const AnswerNote: React.FC<AnswerNoteProps> = ({ title, body, faqAnchor }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        mb: 1.5,
        px: 1.5,
        py: 1,
        borderRadius: 2,
        backgroundColor: "action.hover",
        borderLeft: "3px solid",
        borderLeftColor: "primary.main",
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
      }}
    >
      <InfoOutlinedIcon
        sx={{ fontSize: "1rem", color: "primary.main", mt: "2px", flexShrink: 0 }}
      />
      <Typography variant="caption" sx={{ color: "text.secondary", lineHeight: 1.5 }}>
        <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
          {title}{" "}
        </Box>
        {body}
        {faqAnchor && (
          <>
            {" "}
            <Link
              component="button"
              type="button"
              onClick={() => navigate(`/faq#${faqAnchor}`)}
              sx={{
                color: "primary.main",
                fontWeight: 600,
                fontSize: "inherit",
                fontFamily: "inherit",
                lineHeight: "inherit",
                textDecoration: "none",
                verticalAlign: "baseline",
                border: 0,
                background: "transparent",
                padding: 0,
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
                "&:focus-visible": {
                  outline: "2px solid",
                  outlineColor: "primary.main",
                  outlineOffset: "2px",
                  borderRadius: "2px",
                },
              }}
            >
              Learn more →
            </Link>
          </>
        )}
      </Typography>
    </Box>
  );
};

export default AnswerNote;
